(()=>{'use strict';
class SaleSystem extends HTMLElement{
  connectedCallback(){
    if(this.controller)return;
    this.root=this.closest('[data-wj-sale-root]');
    if(!this.root)return;
    try{this.config=JSON.parse(this.querySelector('script').textContent);}catch{return;}
    this.controller=new AbortController();
    this.money=new Intl.NumberFormat(document.documentElement.lang||'es',{style:'currency',currency:this.config.currency});
    const options={signal:this.controller.signal};
    for(const name of ['wrapjkt:variant-change','wrapjkt:pants-variant-change','wrapjkt:skirt-variant-change','wrapjkt:comodo-variant-change','wrapjkt:ready'])this.root.addEventListener(name,()=>this.update(),options);
    this.root.addEventListener('click',event=>{
      const link=event.target.closest('[data-wjs-pack-link],[data-wjs-newsletter]');
      if(!link)return;
      if(link.hasAttribute('data-wjs-pack-link')){
        const form=this.root.querySelector('[data-pack-form],[data-pant-pack-form],[data-skirt-pack-form],[data-comodo-pack-form]');
        const target=form?.closest('.w-editorial-bundle');
        if(target){if(!target.id)target.id=this.root.id+'-sale-pack';link.hash=target.id;}
      }else{
        const form=document.getElementById('wj-newsletter-form');
        if(form){const input=form.querySelector('input[type="email"]');if(input)setTimeout(()=>input.focus({preventScroll:true}),100);}
      }
    },options);
    this.update();
  }
  update(){
    const variant=this.root.current||this.config.variant;
    const price=Number(variant.price),compare=Number(variant.compare??variant.compare_at_price);
    const sale=Number.isFinite(price)&&price>0&&Number.isFinite(compare)&&compare>price;
    this.root.dataset.wjsOnSale=String(sale);
    this.root.querySelectorAll('[data-wjs-sale]').forEach(element=>element.hidden=!sale);
    if(sale){const percentage=Math.round((compare-price)*100/compare);this.root.querySelectorAll('[data-wjs-percent]').forEach(element=>element.textContent='−'+percentage+'%');}
    const purchasable=variant.available===true&&price>0&&this.root.config?.catalogReady!==false;
    this.root.querySelectorAll('[data-wjs-welcome],[data-wjs-availability]').forEach(element=>element.hidden=!purchasable);
    const welcome=this.root.querySelector('[data-wjs-welcome-price]');
    if(welcome&&price>0)welcome.textContent=this.config.words.welcome.replace('__PRICE__',this.money.format(Math.round(price*.9)/100));
  }
  disconnectedCallback(){this.controller?.abort();this.controller=null;}
}
if(!customElements.get('wj-sale-system'))customElements.define('wj-sale-system',SaleSystem);
})();
